<template>
  <v-card-text>
    <a
      href="https://www.setra.com/wireless"
      class="website-link"
      target="_blank"
      rel="noopener"
      referrerpolicy="strict-origin"
    >
      {{ $t('common.setra') }}
      <v-icon

        x-small
      >mdi-open-in-new</v-icon>
    </a>
    <v-divider vertical />
    <a
      href="https://www.setra.com/terms-and-conditions"
      class="website-link"
      target="_blank"
      rel="noopener"
      referrerpolicy="strict-origin"
    >
      {{ $t('common.terms_and_conditions') }}
      <v-icon

        x-small
      >mdi-open-in-new</v-icon>
    </a>
    <v-divider vertical />
    <a
      href="https://www.setra.com/privacy-policy"
      class="website-link"
      target="_blank"
      rel="noopener"
      referrerpolicy="strict-origin"
    >
      {{ $t('common.privacy_policy') }}
      <v-icon

        x-small
      >mdi-open-in-new</v-icon>
    </a>
  </v-card-text>
</template>

<script>
export default {
  name: 'ExternalLinks',
};
</script>

<style scoped>

</style>
